import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import ResetPasswordForm from './resetPasswordForm';
import ResetPasswordPerformed from './resetPasswordPerformed';
import IconComponent from '../../portal/iconComponent';

@inject('firstAdminRegisterationStore', 'configurationsStore') @observer
export default class ResetPassword extends Component {

    state = {
        resetConfirmed: false
    };

    handleResetPasswordClick = (e) => {

        this.setState({
            resetConfirmed: true
        });
    };

    componentWillMount() {

        this.props.firstAdminRegisterationStore.firstAdminExistence();
    }

    componentDidMount() {
        this.props.configurationsStore.updateStore();
    }

    render() {

        if (this.props.firstAdminRegisterationStore.isFirstAdminExistence == null) {

            return null;
        }

        if (this.props.firstAdminRegisterationStore.isFirstAdminExistence.firstAdminExists === false) {

            return <Redirect to="/" />;
        }

        let formComponent = <ResetPasswordForm handleResetPassword={ this.handleResetPasswordClick } requireEula={ this.props.requireEula } />;

        if (this.state.resetConfirmed === true) {
            formComponent = <ResetPasswordPerformed />;
        }

        return (
            <div className="reset-password-main-wrapper reset-password-container" data-cy="reset-password-screen">
                <div style={ { width: '100%' } }>
                    <IconComponent iconClassName="cx-logo-and-text-icon" />
                </div>

                <div>
                    { formComponent }
                </div>
            </div>
        );
    }
}